import { useSyncExternalStore } from 'react';

/** Smaller differences are browser toolbars collapsing, not an on-screen keyboard. */
const MIN_KEYBOARD_INSET_PX = 80;

function subscribe(onChange: () => void) {
  const viewport = typeof window !== 'undefined' ? window.visualViewport : null;
  if (!viewport) return () => {};
  viewport.addEventListener('resize', onChange);
  viewport.addEventListener('scroll', onChange);
  return () => {
    viewport.removeEventListener('resize', onChange);
    viewport.removeEventListener('scroll', onChange);
  };
}

/**
 * Height of the layout viewport hidden below the visual viewport, which is the
 * on-screen keyboard on iOS (where the layout viewport does not resize). Zero
 * while pinch-zoomed or when the browser already pans the page above the
 * keyboard, so the offset is never applied twice.
 */
export function readKeyboardInset(): number {
  if (typeof window === 'undefined') return 0;
  const viewport = window.visualViewport;
  if (!viewport || Math.abs(viewport.scale - 1) > 0.01) return 0;
  const inset = Math.round(window.innerHeight - viewport.height - viewport.offsetTop);
  return inset >= MIN_KEYBOARD_INSET_PX ? inset : 0;
}

/** Keeps composers above the on-screen keyboard (for example the folded iPhone Duo held sideways, 678×466). */
export function useKeyboardInset(): number {
  return useSyncExternalStore(subscribe, readKeyboardInset, () => 0);
}
